import { post, get, wordpost } from '../network/index.js'
//用户列表
const queryList = data => {
  return post('/mercWebi/userInfo/queryList', data)
}
//用户详情
const queryDetail = data => {
  return post('/mercWebi/userInfo/queryDetail', data)
}
//修改用户
const updateMercUser = data => {
  return post('/mercWebi/userInfo/updateMercUser', data)
}
//修改用户会员等级
const updateLevel = data => {
  return post('/userMemberLevel/level-change', data)
}

//优卡记录
const queryBillList = data => {
  return post('/mercWebi/userCard/queryBillList', data)
}

//优卡活动列表
const queryCardList = data => {
  return post('/mercWebi/userCard/queryList', data)
}
//购买优卡
const buyCard = data => {
  return post('/mercWebi/userCard/buy', data)
}
//充值优卡
const recharge = data => {
  return post('/mercWebi/userCard/recharge', data)
}
//退优卡
const refundCard = data => {
  return post('/mercWebi/userCard/refundCard', data)
}

//用户优卡列表
const queryUserCardList = data => {
  return post('/mercWebi/userInfo/queryCardList', data)
}
//用户优卡延期
const updateExpireTime = data => {
  return post('/mercWebi/userCard/updateExpireTime', data)
}
//修改用户折扣
const updateDiscount = data => {
  return post('/mercWebi/userInfo/updateDiscount', data)
}
//所有优卡
const queryuserCardList = data => {
  return post('/mercWebi/userCard/queryCardList', data)
}
// 获取用戶标签列表-汇总
const listUserLabel = data => {
  return post('/mercWebi/userInfo/listUserLabel', data)
}
// 获取用戶标签列表-明细带分页
const listSysLabel = data => {
  return post('/mercWebi/webLabelInfo/listSysLabel', data)
}
//给用户添加标签
const addUserLabel = data => {
  return post('/mercWebi/userInfo/addUserLabel', data)
}
//标签管理-- > 创建标签信息
const insertSysLabel = data => {
  return post('/mercWebi/webLabelInfo/insertSysLabel', data)
}
//标签管理-- > 获取下拉标签信息列表
const listSysLabelByParam = data => {
  return post('/mercWebi/webLabelInfo/listSysLabelByParam', data)
}
//获取用户标签记录
const userLabelRecord = data => {
  return post('/mercWebi/userInfo/userLabelRecord', data)
}
//用户管理 --> 移除用户标签
const deleteUserLabel = data => {
  return post('/mercWebi/userInfo/deleteUserLabel', data)
}
//发券记录
const couponIssueList = data => {
  return post('/mercWebi/userInfo/couponIssueList', data)
}
//赠券记录
const userCouponTransferList = data => {
  return post('/mercWebi/userInfo/userCouponTransferList', data)
}

//用户流失列表
const queryUserLostList = data => {
  return post('/mercWebi/workWxUser/queryUserLostList', data)
}

// 子账号列表
const queryBypassAccountList = data => {
  return post('/mercWebi/webAccountInfo/listAccountInfo', data)
}
// 子账号详情
const queryBypassAccountInfo = data => {
  return get(`/mercWebi/webAccountInfo/queryAccountByID/${data}`)
}
// 子账号创建
const addBypassAccount = data => {
  return post('/mercWebi/webAccountInfo/registerAccount', data)
}
// 子账号编辑
const editBypassAccount = data => {
  return post('/mercWebi/webAccountInfo/modifyAccount', data)
}
// 子账号下可供操作的店铺
const queryBypassAccountStorelist = data => {
  return post('/mercWebi/webAccountInfo/listStoreInfoByAccountId', data)
}

// 子账号角色列表
const queryRoleList = data => {
  return post('/mercWebi/webAccountInfo/listRoles', data)
}
// 子账号角色删除
const deleteRole = data => {
  return post('/mercWebi/webAccountInfo/deleteRole', data)
}
// 子账号角色详情
const queryRoleInfo = data => {
  return get(`/mercWebi/webAccountInfo/listRoleByID/${data}`)
}
// 子账号角色创建
const addRole = data => {
  return post('/mercWebi/webAccountInfo/insertRole', data)
}
// 子账号角色修改
const editRole = data => {
  return post('/mercWebi/webAccountInfo/modifyRole', data)
}
// 子账号角色状态
const setRoleStatus = data => {
  return post('/mercWebi/webAccountInfo/modifyRoleStatus', data)
}
// 子账号角色权限列表
const queryRolePermission = data => {
  return post('/mercWebi/webAccountInfo/listPermissionInfo', data)
}
// 商家所有角色
const queryAllRole = data => {
  return get(`/mercWebi/webAccountInfo/listRolesByMercId/${data.mercId}`)
}
// 导入用户-列表
const userImportList = data => {
  return post('/mercWebi/impUser/queryImportPage', data)
}
// 导入用户-详情列表
const userImportDetailsList = data => {
  return post('/mercWebi/impUser/queryDetailPage', data)
}
// 导入用户-详情
const userImportDetails = data => {
  return get(`/mercWebi/impUser/queryDetail?id=${data}`)
}
// 导入用户-导入提交
const userImportData = data => {
  // return post('/mercWebi/impUser/template/data', data, {
  //   headers: { 'Content-Type': 'application/json' }
  // })
  return post('/mercWebi/impUser/importUserExcel', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
// 导入用户-失败数据下载
const userImportFailDownload = data => {
  return post('/mercWebi/impUser/failed/download', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, responseType: 'blob' })
}

// 用户-分销-改为团长
const setLeaderUser = data => {
  return post('/mercWebi/userInfo/setLeaderUser', data)
}

// 用户-分销-修改用户身份
const updateUserLevel = data => {
  return post('/mercWebi/userInfo/updateUserLevel', data)
}

// 用户-优卡适用店铺
const queryApplyStore = data => {
  return post('/mercWebi/userInfo/queryApplyStore', data)
}
// 用户-修改优卡适用店铺
const modifyApplyStore = data => {
  return post('/mercWebi/userInfo/modifyApplyStore', data)
}
// 用户-修改用户优卡折扣
const modifyUserCardDiscount = data => {
  return post('/mercWebi/userInfo/modifyUserCardDiscount', data)
}

// 用户分群-筛选用户
const searchUserGroupUserList = data => {
  return post('/mercWebi/userGroupInfo/searchUserListByPage', data)
}

// 用户分群-保存用户分群
const saveUserGroupInfo = data => {
  return post('/mercWebi/userGroupInfo/saveUserGroupInfo', data)
}

// 用户分群-删除
const deleteUserGroupInfo = data => {
  return post('/mercWebi/userGroupInfo/deleteUserGroupInfo', data)
}

// 用户分群-列表查询(分页)
const getUserGroupList = data => {
  return post('/mercWebi/userGroupInfo/listByPage', data)
}

// 用户分群-列表查询(全部)
const getAllUserGroupList = data => {
  return post('/mercWebi/userGroupInfo/userGroupList', data)
}

// 用户分群-根据分群id查询用户列表
const getUserGroupUserList = data => {
  return post('/mercWebi/userGroupInfo/listByGroupId', data)
}

// 用户分群-查询分群详情
const queryUserGroupInfo = data => {
  return post('/mercWebi/userGroupInfo/findUserGroupInfo', data)
}

// 优惠券-批量发券记录列表
const getCouponBatchList = data => {
  return post('/mercWebi/userInfo/couponBatchList', data)
}
// 优惠券-批量发券详情
const getCouponBatchDetail = data => {
  return post('/mercWebi/userInfo/couponBatchDetail', data)
}
// 优惠券-批量发券用户列表
const getCouponBatchUserList = data => {
  return post('/mercWebi/userInfo/couponBatchUserList', data)
}
// 优惠券-批量发券取消所有未领取
const setCouponBatchCancelAll = data => {
  return post('/mercWebi/userInfo/couponBatchCancelAll', data)
}
// 优惠券-批量发券取消单个用户未领券
const setCouponBatchCancelOne = data => {
  return post('/mercWebi/userInfo/couponBatchCancelOne', data)
}

export default {
  queryList,
  queryDetail,
  updateMercUser,
  updateLevel,
  queryBillList,
  queryCardList,
  buyCard,
  recharge,
  refundCard,
  queryUserCardList,
  updateExpireTime,
  updateDiscount,
  queryuserCardList,
  listUserLabel,
  listSysLabel,
  addUserLabel,
  insertSysLabel,
  listSysLabelByParam,
  userLabelRecord,
  deleteUserLabel,
  couponIssueList,
  userCouponTransferList,
  queryUserLostList,
  queryBypassAccountList,
  queryBypassAccountInfo,
  addBypassAccount,
  editBypassAccount,
  queryBypassAccountStorelist,
  queryRoleList,
  deleteRole,
  queryRoleInfo,
  addRole,
  editRole,
  setRoleStatus,
  queryRolePermission,
  queryAllRole,
  userImportData,
  userImportList,
  userImportDetailsList,
  userImportDetails,
  userImportFailDownload,
  setLeaderUser,
  updateUserLevel,
  queryApplyStore,
  modifyApplyStore,
  modifyUserCardDiscount,
  searchUserGroupUserList,
  saveUserGroupInfo,
  deleteUserGroupInfo,
  getUserGroupList,
  getAllUserGroupList,
  getUserGroupUserList,
  queryUserGroupInfo,
  getCouponBatchList,
  getCouponBatchDetail,
  getCouponBatchUserList,
  setCouponBatchCancelAll,
  setCouponBatchCancelOne
}
